import moment from 'moment'
import { getChineseWeekday } from '@/modules/chat/util/ChatBotUtil'

export function getDateFromDate(dateString, format) {
  return moment(dateString).format(format)
}

export function calculateWeekday(inputDate) {
  if (moment(inputDate, 'YYYY-MM-DD').isValid()) {
    const weekDay = moment(inputDate, 'YYYY-MM-DD').format('dddd')
    return getChineseWeekday(weekDay)
  } else {
    return null
  }
}

export function getTimeFromDate(dateString) {
  return moment(dateString).format('HH:mm')
}

export function checkFirstChar(str) {
  if (str.length === 0) return '' // 处理空字符串

  const firstCharCode = str.charCodeAt(0)

  // 判断是否为英文字母（A-Z/a-z）
  if ((firstCharCode >= 65 && firstCharCode <= 90) || (firstCharCode >= 97 && firstCharCode <= 122)) {
    return 'english'
  }
  // 判断是否为中文字符（常用范围）
  else if (firstCharCode >= 19968 && firstCharCode <= 40869) {
    return 'chinese'
  }
  // 其他字符（如数字、符号等）
  else {
    return 'other'
  }
}

export function isMobile() {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileRegex = /(iphone|ipod|ipad|android|blackberry|windows phone|opera mini|iemobile)/;
  const isNarrowScreen = window.innerWidth <= 768;
  return mobileRegex.test(userAgent) || isNarrowScreen;
}

